import React, {Component} from 'react';
import {Redirect} from "react-router-dom";

class LandingPage extends Component {
    render() {
        return <Redirect to="/updates" />
    }
}

export default LandingPage;